import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import SoftBadge from 'components/common/SoftBadge';
import ModalAsociarPlanFacturacion from '../../cliente/components/ModalAsociarPlanFacturacion';

/**
 * Componente para mostrar el plan de facturación asociado a un producto
 * o un botón para asociarlo si no tiene uno
 */
const PlanFacturacionAsociado = ({ product, orden, onPlanAsociado }) => {
    const [showModalAsociar, setShowModalAsociar] = useState(false);

    // Parsear el JSON del plan de facturación
    const planesFacturacion = product.vJsonPlanFacturacion
        ? JSON.parse(product.vJsonPlanFacturacion)
        : [];

    console.log("planesFacturacion" ,planesFacturacion);

    const tienePlanAsociado = planesFacturacion[0].idPlanFacturaMx != 0;

    console.log("tienePlanAsociado", tienePlanAsociado);

    const handleAbrirModal = () => {
        setShowModalAsociar(true);
    };

    const handleCerrarModal = () => {
        setShowModalAsociar(false);
    };

    const handlePlanAsociadoExitoso = () => {
        if (onPlanAsociado) {
            onPlanAsociado();
        }
        handleCerrarModal();
    };

    return (
        <>
            <Row className="mt-0">
                <Col className="ps-0 ms-0">
                    {tienePlanAsociado ? (
                        <div className="d-flex align-items-center gap-2">
                            <SoftBadge bg="success">Plan Asociado</SoftBadge>
                            <span className="text-muted small">
                                RFC: <strong>{planesFacturacion[0].vRfc}</strong>
                            </span>
                            {planesFacturacion[0].iCantidadTimbres && (
                                <span className="text-muted small">
                                    | Timbres: <strong>{planesFacturacion[0].iCantidadTimbres}</strong>
                                </span>
                            )}
                            {planesFacturacion[0].bIsPaid !== undefined && (
                                <SoftBadge bg={planesFacturacion[0].bIsPaid ? "info" : "warning"}>
                                    {planesFacturacion[0].bIsPaid ? "Pagado" : "Pendiente de Pago"}
                                </SoftBadge>
                            )}
                        </div>
                    ) : (
                        <Col
                            className="pr-1 mb-2"
                            style={{ cursor: 'pointer' }}
                            onClick={handleAbrirModal}
                        >
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id="tooltip"><strong>Asociar plan de facturación</strong></Tooltip>}
                            >
                                <span>
                                    <FontAwesomeIcon
                                        className="me-2"
                                        icon={icon({ name: 'file-invoice', style: "solid" })}
                                        style={{ color: "#28a745" }}
                                        size="xl"
                                    />
                                    <span className="text-muted">
                                        Click para <strong>asociar plan de facturación</strong>
                                    </span>
                                </span>
                            </OverlayTrigger>
                        </Col>
                    )}
                </Col>
            </Row>

            <ModalAsociarPlanFacturacion
                show={showModalAsociar}
                onHide={handleCerrarModal}
                ordenSeleccionada={{
                    idOrdenDetalle: product.idOrdenDetalle,
                    vNombreProducto: product.vNombreProducto
                }}
                onPlanAsociado={handlePlanAsociadoExitoso}
                idCliente={orden.idClienteAkasia}
            />
        </>
    );
};

PlanFacturacionAsociado.propTypes = {
    product: PropTypes.object.isRequired,
    orden: PropTypes.object.isRequired,
    onPlanAsociado: PropTypes.func
};

export default PlanFacturacionAsociado;
